/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb = require('../../../../../../../../github.com/solo-io/solo-kit/api/external/envoy/api/v2/core/base_pb.js');
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
var google_rpc_status_pb = require('../../../../../../../../google/rpc/status_pb.js');
var extproto_ext_pb = require('../../../../../../../../extproto/ext_pb.js');
goog.exportSymbol('proto.envoy.api.v2.DeltaDiscoveryRequest', null, global);
goog.exportSymbol('proto.envoy.api.v2.DeltaDiscoveryResponse', null, global);
goog.exportSymbol('proto.envoy.api.v2.DiscoveryRequest', null, global);
goog.exportSymbol('proto.envoy.api.v2.DiscoveryResponse', null, global);
goog.exportSymbol('proto.envoy.api.v2.Resource', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.DiscoveryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.envoy.api.v2.DiscoveryRequest.repeatedFields_, null);
};
goog.inherits(proto.envoy.api.v2.DiscoveryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.DiscoveryRequest.displayName = 'proto.envoy.api.v2.DiscoveryRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.envoy.api.v2.DiscoveryRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.DiscoveryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.DiscoveryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.DiscoveryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.DiscoveryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    versionInfo: jspb.Message.getFieldWithDefault(msg, 1, ""),
    node: (f = msg.getNode()) && github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb.Node.toObject(includeInstance, f),
    resourceNamesList: jspb.Message.getRepeatedField(msg, 3),
    typeUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    responseNonce: jspb.Message.getFieldWithDefault(msg, 5, ""),
    errorDetail: (f = msg.getErrorDetail()) && google_rpc_status_pb.Status.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.DiscoveryRequest}
 */
proto.envoy.api.v2.DiscoveryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.DiscoveryRequest;
  return proto.envoy.api.v2.DiscoveryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.DiscoveryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.DiscoveryRequest}
 */
proto.envoy.api.v2.DiscoveryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionInfo(value);
      break;
    case 2:
      var value = new github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb.Node;
      reader.readMessage(value,github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb.Node.deserializeBinaryFromReader);
      msg.setNode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addResourceNames(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTypeUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponseNonce(value);
      break;
    case 6:
      var value = new google_rpc_status_pb.Status;
      reader.readMessage(value,google_rpc_status_pb.Status.deserializeBinaryFromReader);
      msg.setErrorDetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.DiscoveryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.DiscoveryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.DiscoveryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.DiscoveryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersionInfo();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNode();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb.Node.serializeBinaryToWriter
    );
  }
  f = message.getResourceNamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getTypeUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getResponseNonce();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getErrorDetail();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_rpc_status_pb.Status.serializeBinaryToWriter
    );
  }
};


/**
 * optional string version_info = 1;
 * @return {string}
 */
proto.envoy.api.v2.DiscoveryRequest.prototype.getVersionInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.envoy.api.v2.DiscoveryRequest.prototype.setVersionInfo = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional solo.io.envoy.api.v2.core.Node node = 2;
 * @return {?proto.solo.io.envoy.api.v2.core.Node}
 */
proto.envoy.api.v2.DiscoveryRequest.prototype.getNode = function() {
  return /** @type{?proto.solo.io.envoy.api.v2.core.Node} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb.Node, 2));
};


/** @param {?proto.solo.io.envoy.api.v2.core.Node|undefined} value */
proto.envoy.api.v2.DiscoveryRequest.prototype.setNode = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.envoy.api.v2.DiscoveryRequest.prototype.clearNode = function() {
  this.setNode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.DiscoveryRequest.prototype.hasNode = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string resource_names = 3;
 * @return {!Array<string>}
 */
proto.envoy.api.v2.DiscoveryRequest.prototype.getResourceNamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.envoy.api.v2.DiscoveryRequest.prototype.setResourceNamesList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.envoy.api.v2.DiscoveryRequest.prototype.addResourceNames = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


proto.envoy.api.v2.DiscoveryRequest.prototype.clearResourceNamesList = function() {
  this.setResourceNamesList([]);
};


/**
 * optional string type_url = 4;
 * @return {string}
 */
proto.envoy.api.v2.DiscoveryRequest.prototype.getTypeUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.envoy.api.v2.DiscoveryRequest.prototype.setTypeUrl = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string response_nonce = 5;
 * @return {string}
 */
proto.envoy.api.v2.DiscoveryRequest.prototype.getResponseNonce = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.envoy.api.v2.DiscoveryRequest.prototype.setResponseNonce = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.rpc.Status error_detail = 6;
 * @return {?proto.google.rpc.Status}
 */
proto.envoy.api.v2.DiscoveryRequest.prototype.getErrorDetail = function() {
  return /** @type{?proto.google.rpc.Status} */ (
    jspb.Message.getWrapperField(this, google_rpc_status_pb.Status, 6));
};


/** @param {?proto.google.rpc.Status|undefined} value */
proto.envoy.api.v2.DiscoveryRequest.prototype.setErrorDetail = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


proto.envoy.api.v2.DiscoveryRequest.prototype.clearErrorDetail = function() {
  this.setErrorDetail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.DiscoveryRequest.prototype.hasErrorDetail = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.DiscoveryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.envoy.api.v2.DiscoveryResponse.repeatedFields_, null);
};
goog.inherits(proto.envoy.api.v2.DiscoveryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.DiscoveryResponse.displayName = 'proto.envoy.api.v2.DiscoveryResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.envoy.api.v2.DiscoveryResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.DiscoveryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.DiscoveryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.DiscoveryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.DiscoveryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    versionInfo: jspb.Message.getFieldWithDefault(msg, 1, ""),
    resourcesList: jspb.Message.toObjectList(msg.getResourcesList(),
    google_protobuf_any_pb.Any.toObject, includeInstance),
    canary: jspb.Message.getFieldWithDefault(msg, 3, false),
    typeUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    nonce: jspb.Message.getFieldWithDefault(msg, 5, ""),
    controlPlane: (f = msg.getControlPlane()) && github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb.ControlPlane.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.DiscoveryResponse}
 */
proto.envoy.api.v2.DiscoveryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.DiscoveryResponse;
  return proto.envoy.api.v2.DiscoveryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.DiscoveryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.DiscoveryResponse}
 */
proto.envoy.api.v2.DiscoveryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersionInfo(value);
      break;
    case 2:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.addResources(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCanary(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTypeUrl(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNonce(value);
      break;
    case 6:
      var value = new github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb.ControlPlane;
      reader.readMessage(value,github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb.ControlPlane.deserializeBinaryFromReader);
      msg.setControlPlane(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.DiscoveryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.DiscoveryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.DiscoveryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.DiscoveryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVersionInfo();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResourcesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
  f = message.getCanary();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTypeUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNonce();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getControlPlane();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb.ControlPlane.serializeBinaryToWriter
    );
  }
};


/**
 * optional string version_info = 1;
 * @return {string}
 */
proto.envoy.api.v2.DiscoveryResponse.prototype.getVersionInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.envoy.api.v2.DiscoveryResponse.prototype.setVersionInfo = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated google.protobuf.Any resources = 2;
 * @return {!Array<!proto.google.protobuf.Any>}
 */
proto.envoy.api.v2.DiscoveryResponse.prototype.getResourcesList = function() {
  return /** @type{!Array<!proto.google.protobuf.Any>} */ (
    jspb.Message.getRepeatedWrapperField(this, google_protobuf_any_pb.Any, 2));
};


/** @param {!Array<!proto.google.protobuf.Any>} value */
proto.envoy.api.v2.DiscoveryResponse.prototype.setResourcesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.google.protobuf.Any=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.Any}
 */
proto.envoy.api.v2.DiscoveryResponse.prototype.addResources = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.google.protobuf.Any, opt_index);
};


proto.envoy.api.v2.DiscoveryResponse.prototype.clearResourcesList = function() {
  this.setResourcesList([]);
};


/**
 * optional bool canary = 3;
 * Note that Boolean fields may be set to 0/1 when serialized from a Java server.
 * You should avoid comparisons like {@code val === true/false} in those cases.
 * @return {boolean}
 */
proto.envoy.api.v2.DiscoveryResponse.prototype.getCanary = function() {
  return /** @type {boolean} */ (jspb.Message.getFieldWithDefault(this, 3, false));
};


/** @param {boolean} value */
proto.envoy.api.v2.DiscoveryResponse.prototype.setCanary = function(value) {
  jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string type_url = 4;
 * @return {string}
 */
proto.envoy.api.v2.DiscoveryResponse.prototype.getTypeUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.envoy.api.v2.DiscoveryResponse.prototype.setTypeUrl = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string nonce = 5;
 * @return {string}
 */
proto.envoy.api.v2.DiscoveryResponse.prototype.getNonce = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.envoy.api.v2.DiscoveryResponse.prototype.setNonce = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional solo.io.envoy.api.v2.core.ControlPlane control_plane = 6;
 * @return {?proto.solo.io.envoy.api.v2.core.ControlPlane}
 */
proto.envoy.api.v2.DiscoveryResponse.prototype.getControlPlane = function() {
  return /** @type{?proto.solo.io.envoy.api.v2.core.ControlPlane} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb.ControlPlane, 6));
};


/** @param {?proto.solo.io.envoy.api.v2.core.ControlPlane|undefined} value */
proto.envoy.api.v2.DiscoveryResponse.prototype.setControlPlane = function(value) {
  jspb.Message.setWrapperField(this, 6, value);
};


proto.envoy.api.v2.DiscoveryResponse.prototype.clearControlPlane = function() {
  this.setControlPlane(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.DiscoveryResponse.prototype.hasControlPlane = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.DeltaDiscoveryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.envoy.api.v2.DeltaDiscoveryRequest.repeatedFields_, null);
};
goog.inherits(proto.envoy.api.v2.DeltaDiscoveryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.DeltaDiscoveryRequest.displayName = 'proto.envoy.api.v2.DeltaDiscoveryRequest';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.repeatedFields_ = [3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.DeltaDiscoveryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.DeltaDiscoveryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    node: (f = msg.getNode()) && github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb.Node.toObject(includeInstance, f),
    typeUrl: jspb.Message.getFieldWithDefault(msg, 2, ""),
    resourceNamesSubscribeList: jspb.Message.getRepeatedField(msg, 3),
    resourceNamesUnsubscribeList: jspb.Message.getRepeatedField(msg, 4),
    initialResourceVersionsMap: (f = msg.getInitialResourceVersionsMap()) ? f.toObject(includeInstance, undefined) : [],
    responseNonce: jspb.Message.getFieldWithDefault(msg, 6, ""),
    errorDetail: (f = msg.getErrorDetail()) && google_rpc_status_pb.Status.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.DeltaDiscoveryRequest}
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.DeltaDiscoveryRequest;
  return proto.envoy.api.v2.DeltaDiscoveryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.DeltaDiscoveryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.DeltaDiscoveryRequest}
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb.Node;
      reader.readMessage(value,github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb.Node.deserializeBinaryFromReader);
      msg.setNode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTypeUrl(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addResourceNamesSubscribe(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addResourceNamesUnsubscribe(value);
      break;
    case 5:
      var value = msg.getInitialResourceVersionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "");
         });
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setResponseNonce(value);
      break;
    case 7:
      var value = new google_rpc_status_pb.Status;
      reader.readMessage(value,google_rpc_status_pb.Status.deserializeBinaryFromReader);
      msg.setErrorDetail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.DeltaDiscoveryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.DeltaDiscoveryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNode();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb.Node.serializeBinaryToWriter
    );
  }
  f = message.getTypeUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getResourceNamesSubscribeList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getResourceNamesUnsubscribeList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getInitialResourceVersionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
  f = message.getResponseNonce();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getErrorDetail();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_rpc_status_pb.Status.serializeBinaryToWriter
    );
  }
};


/**
 * optional solo.io.envoy.api.v2.core.Node node = 1;
 * @return {?proto.solo.io.envoy.api.v2.core.Node}
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.getNode = function() {
  return /** @type{?proto.solo.io.envoy.api.v2.core.Node} */ (
    jspb.Message.getWrapperField(this, github_com_solo$io_solo$kit_api_external_envoy_api_v2_core_base_pb.Node, 1));
};


/** @param {?proto.solo.io.envoy.api.v2.core.Node|undefined} value */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.setNode = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.clearNode = function() {
  this.setNode(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.hasNode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string type_url = 2;
 * @return {string}
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.getTypeUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.setTypeUrl = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string resource_names_subscribe = 3;
 * @return {!Array<string>}
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.getResourceNamesSubscribeList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/** @param {!Array<string>} value */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.setResourceNamesSubscribeList = function(value) {
  jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.addResourceNamesSubscribe = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.clearResourceNamesSubscribeList = function() {
  this.setResourceNamesSubscribeList([]);
};


/**
 * repeated string resource_names_unsubscribe = 4;
 * @return {!Array<string>}
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.getResourceNamesUnsubscribeList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/** @param {!Array<string>} value */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.setResourceNamesUnsubscribeList = function(value) {
  jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.addResourceNamesUnsubscribe = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.clearResourceNamesUnsubscribeList = function() {
  this.setResourceNamesUnsubscribeList([]);
};


/**
 * map<string, string> initial_resource_versions = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.getInitialResourceVersionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.clearInitialResourceVersionsMap = function() {
  this.getInitialResourceVersionsMap().clear();
};


/**
 * optional string response_nonce = 6;
 * @return {string}
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.getResponseNonce = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/** @param {string} value */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.setResponseNonce = function(value) {
  jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.rpc.Status error_detail = 7;
 * @return {?proto.google.rpc.Status}
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.getErrorDetail = function() {
  return /** @type{?proto.google.rpc.Status} */ (
    jspb.Message.getWrapperField(this, google_rpc_status_pb.Status, 7));
};


/** @param {?proto.google.rpc.Status|undefined} value */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.setErrorDetail = function(value) {
  jspb.Message.setWrapperField(this, 7, value);
};


proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.clearErrorDetail = function() {
  this.setErrorDetail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.DeltaDiscoveryRequest.prototype.hasErrorDetail = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.DeltaDiscoveryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.envoy.api.v2.DeltaDiscoveryResponse.repeatedFields_, null);
};
goog.inherits(proto.envoy.api.v2.DeltaDiscoveryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.DeltaDiscoveryResponse.displayName = 'proto.envoy.api.v2.DeltaDiscoveryResponse';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.envoy.api.v2.DeltaDiscoveryResponse.repeatedFields_ = [2,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.DeltaDiscoveryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.DeltaDiscoveryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.DeltaDiscoveryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    systemVersionInfo: jspb.Message.getFieldWithDefault(msg, 1, ""),
    resourcesList: jspb.Message.toObjectList(msg.getResourcesList(),
    proto.envoy.api.v2.Resource.toObject, includeInstance),
    typeUrl: jspb.Message.getFieldWithDefault(msg, 4, ""),
    removedResourcesList: jspb.Message.getRepeatedField(msg, 6),
    nonce: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.DeltaDiscoveryResponse}
 */
proto.envoy.api.v2.DeltaDiscoveryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.DeltaDiscoveryResponse;
  return proto.envoy.api.v2.DeltaDiscoveryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.DeltaDiscoveryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.DeltaDiscoveryResponse}
 */
proto.envoy.api.v2.DeltaDiscoveryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSystemVersionInfo(value);
      break;
    case 2:
      var value = new proto.envoy.api.v2.Resource;
      reader.readMessage(value,proto.envoy.api.v2.Resource.deserializeBinaryFromReader);
      msg.addResources(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTypeUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addRemovedResources(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setNonce(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.DeltaDiscoveryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.DeltaDiscoveryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.DeltaDiscoveryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemVersionInfo();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResourcesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.envoy.api.v2.Resource.serializeBinaryToWriter
    );
  }
  f = message.getTypeUrl();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRemovedResourcesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getNonce();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string system_version_info = 1;
 * @return {string}
 */
proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.getSystemVersionInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.setSystemVersionInfo = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated Resource resources = 2;
 * @return {!Array<!proto.envoy.api.v2.Resource>}
 */
proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.getResourcesList = function() {
  return /** @type{!Array<!proto.envoy.api.v2.Resource>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.envoy.api.v2.Resource, 2));
};


/** @param {!Array<!proto.envoy.api.v2.Resource>} value */
proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.setResourcesList = function(value) {
  jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.envoy.api.v2.Resource=} opt_value
 * @param {number=} opt_index
 * @return {!proto.envoy.api.v2.Resource}
 */
proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.addResources = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.envoy.api.v2.Resource, opt_index);
};


proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.clearResourcesList = function() {
  this.setResourcesList([]);
};


/**
 * optional string type_url = 4;
 * @return {string}
 */
proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.getTypeUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.setTypeUrl = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string removed_resources = 6;
 * @return {!Array<string>}
 */
proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.getRemovedResourcesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/** @param {!Array<string>} value */
proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.setRemovedResourcesList = function(value) {
  jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.addRemovedResources = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.clearRemovedResourcesList = function() {
  this.setRemovedResourcesList([]);
};


/**
 * optional string nonce = 5;
 * @return {string}
 */
proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.getNonce = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/** @param {string} value */
proto.envoy.api.v2.DeltaDiscoveryResponse.prototype.setNonce = function(value) {
  jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.envoy.api.v2.Resource = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.envoy.api.v2.Resource.repeatedFields_, null);
};
goog.inherits(proto.envoy.api.v2.Resource, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.envoy.api.v2.Resource.displayName = 'proto.envoy.api.v2.Resource';
}
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.envoy.api.v2.Resource.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.envoy.api.v2.Resource.prototype.toObject = function(opt_includeInstance) {
  return proto.envoy.api.v2.Resource.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.envoy.api.v2.Resource} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.Resource.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    aliasesList: jspb.Message.getRepeatedField(msg, 4),
    version: jspb.Message.getFieldWithDefault(msg, 1, ""),
    resource: (f = msg.getResource()) && google_protobuf_any_pb.Any.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.envoy.api.v2.Resource}
 */
proto.envoy.api.v2.Resource.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.envoy.api.v2.Resource;
  return proto.envoy.api.v2.Resource.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.envoy.api.v2.Resource} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.envoy.api.v2.Resource}
 */
proto.envoy.api.v2.Resource.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addAliases(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setVersion(value);
      break;
    case 2:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setResource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.envoy.api.v2.Resource.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.envoy.api.v2.Resource.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.envoy.api.v2.Resource} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.envoy.api.v2.Resource.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAliasesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getVersion();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getResource();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.envoy.api.v2.Resource.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.envoy.api.v2.Resource.prototype.setName = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string aliases = 4;
 * @return {!Array<string>}
 */
proto.envoy.api.v2.Resource.prototype.getAliasesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/** @param {!Array<string>} value */
proto.envoy.api.v2.Resource.prototype.setAliasesList = function(value) {
  jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {!string} value
 * @param {number=} opt_index
 */
proto.envoy.api.v2.Resource.prototype.addAliases = function(value, opt_index) {
  jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


proto.envoy.api.v2.Resource.prototype.clearAliasesList = function() {
  this.setAliasesList([]);
};


/**
 * optional string version = 1;
 * @return {string}
 */
proto.envoy.api.v2.Resource.prototype.getVersion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.envoy.api.v2.Resource.prototype.setVersion = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Any resource = 2;
 * @return {?proto.google.protobuf.Any}
 */
proto.envoy.api.v2.Resource.prototype.getResource = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 2));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.envoy.api.v2.Resource.prototype.setResource = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.envoy.api.v2.Resource.prototype.clearResource = function() {
  this.setResource(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.envoy.api.v2.Resource.prototype.hasResource = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.envoy.api.v2);
